import { useGoogleMap } from '@react-google-maps/api';
import React from 'react';
import type { ISelectableItem } from '@hotelplan/components.common.map-pin';
import { mapCoordinatesToLatLng } from '@hotelplan/components.common.map-pin';
import { isFdrWishlistProductHotel } from 'fdr/components/candidate/fdr-wishlist/fdr-wishlist.types';
import FdrMapControlsOverlay from 'fdr/components/local/fdr-map/fdr-map-controls-overlay';
import FdrMapCurrentZoomControl from 'fdr/components/local/fdr-map/fdr-map-current-zoom-control';
import { FdrMapItemsCountControl } from 'fdr/components/local/fdr-map/fdr-map-items-count-control';
import { FdrProductPin } from 'fdr/components/local/fdr-srl-map/fdr-srl-map.types';
import useWishlistMapItems from './fdr-use-wishlist-map-items';
import FdrWishlistMapItems from './fdr-wishlist-map-items';

type Product = FdrProductPin;

interface IWishlistMapProps {
  onSelect?(objects: Product[], selectableItem: ISelectableItem): void;
  onClickOnSelectedPin?(): void;
}

const FdrWishlistMap: React.FC<IWishlistMapProps> = ({
  onSelect,
  onClickOnSelectedPin,
}) => {
  const map = useGoogleMap();

  const { loading, mapItems } = useWishlistMapItems({
    onCompleted(items) {
      const center = items
        ?.map(i => i.product)
        .filter(isFdrWishlistProductHotel)
        .map(i => i.coordinates)
        .find(Boolean);

      if (center) {
        map?.setCenter(mapCoordinatesToLatLng(center));
      }
    },
  });

  return (
    <FdrMapControlsOverlay>
      <FdrMapItemsCountControl loading={loading} count={mapItems.length} />
      <FdrMapCurrentZoomControl />
      <FdrWishlistMapItems
        mapItems={mapItems}
        onProductClick={(product, pin) => onSelect?.([product], pin)}
        onClickOnSelectedPin={onClickOnSelectedPin}
      />
    </FdrMapControlsOverlay>
  );
};

export default FdrWishlistMap;
